"use strict";
var Chunker_1 = require('./Chunker');
exports.Chunker = Chunker_1.default;
var ndarray = require('ndarray');
exports.generator = {
    Valley: function (i, j, k) {
        return j <= (i * i + k * k) * 31 / (32 * 32 * 2) + 1 ? 1 + (1 << 15) : 0;
    },
};
function generate(lo, hi, fn) {
    // To fix the display gaps, we need to pad the bounds
    lo[0]--;
    lo[1]--;
    lo[2]--;
    hi[0]++;
    hi[1]++;
    hi[2]++;
    var dims = [hi[2] - lo[2], hi[1] - lo[1], hi[0] - lo[0]];
    var data = ndarray(new Uint16Array(dims[2] * dims[1] * dims[0]), dims);
    for (var k = lo[2]; k < hi[2]; k++)
        for (var j = lo[1]; j < hi[1]; j++)
            for (var i = lo[0]; i < hi[0]; i++) {
                data.set(k - lo[2], j - lo[1], i - lo[0], fn(i, j, k));
            }
    return data;
}
exports.generate = generate;
// module.exports.scale = function ( x, fromLow, fromHigh, toLow, toHigh ) {
//   return ( x - fromLow ) * ( toHigh - toLow ) / ( fromHigh - fromLow ) + toLow
// }
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/voxel/index.js
 ** module id = 939
 ** module chunks = 0
 **/